export function getAbTestFeatureStartedAt(abTest) {
  return abTest?.publishedAt ?? abTest?.createdAt ?? null;
}
